export const container = {
  paddingLeft: '3vw',
  paddingRight: '3vw',
};
